import { Card, Grid, Snackbar, Alert } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import { useAuth } from "context/AuthContext";
import { useState, useEffect } from "react";
import { supabase } from "supabaseClient";

const ProfileDetails = () => {
  const { user, updateUser } = useAuth();
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, severity: "info", message: "" });

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const phoneNumber = value.replace(/\D/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 3) return `(${phoneNumber}`;
    if (phoneNumberLength < 8) return `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
    return `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 7)}-${phoneNumber.slice(7, 11)}`;
  };

  useEffect(() => {
    if (user) {
      setFullName(user.user_metadata?.full_name || "");
      // Get phone from metadata and remove country code for display
      const displayPhone = user.user_metadata?.phone ? user.user_metadata.phone.replace(/^\+55/, "") : "";
      setPhone(formatPhoneNumber(displayPhone));
    }
  }, [user]);

  const handlePhoneChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setPhone(formattedPhoneNumber);
  };

  const handleFullNameBlur = async (e) => {
    const newFullName = e.target.value;
    if (newFullName === user.user_metadata?.full_name) return;

    const { data, error } = await supabase.auth.updateUser({
      data: { ...user.user_metadata, full_name: newFullName },
    });

    if (error) {
      setSnackbar({ open: true, severity: "error", message: `Erro: ${error.message}` });
    } else if (data.user) {
      updateUser(data.user);
      setSnackbar({ open: true, severity: "success", message: "Nome atualizado com sucesso!" });
    }
  };

  const handlePhoneBlur = async (e) => {
    const localPhone = e.target.value.replace(/\D/g, "");
    if (localPhone.length < 10) return;

    const e164Phone = `+55${localPhone}`;
    if (e164Phone === user.user_metadata?.phone) return;

    const { data, error } = await supabase.auth.updateUser({
      data: { ...user.user_metadata, phone: e164Phone },
    });

    if (error) {
      setSnackbar({ open: true, severity: "error", message: `Erro: ${error.message}` });
    } else if (data.user) {
      updateUser(data.user);
      setSnackbar({ open: true, severity: "success", message: "Celular atualizado com sucesso!" });
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="24px">
          <VuiTypography color="white" variant="lg" fontWeight="bold">
            Detalhes do Perfil
          </VuiTypography>
        </VuiBox>
        <VuiBox flexGrow={1} display="flex" flexDirection="column">
          <Grid container spacing={2} direction="column">
            <Grid item xs={12}>
              <VuiInput
                label="Nome Completo"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                onBlur={handleFullNameBlur}
                fullWidth
                placeholder="Nome Completo"
              />
            </Grid>
            <Grid item xs={12}>
              <VuiInput
                label="Celular"
                value={phone}
                onChange={handlePhoneChange}
                onBlur={handlePhoneBlur}
                fullWidth
                placeholder="(99) 99999-9999"
              />
            </Grid>
            <Grid item xs={12}>
              <VuiInput
                label="Email"
                value={user?.email}
                fullWidth
                disabled
                placeholder="Email"
              />
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default ProfileDetails;
